import React from 'react'
import { Check, Car } from 'lucide-react'
import { cn } from '../../utils/cn'

interface StepperProps {
 currentStep: number
 totalSteps: number
 steps: string[]
 onStepClick?: (step: number) => void
 vehicleName?: string
}

export const Stepper: React.FC<StepperProps> = ({
 currentStep,
 steps,
 onStepClick,
 vehicleName,
}) => {
 const totalSteps = steps.length

 return (
 <div className="bg-card border border-border rounded-lg p-5">
 {vehicleName && (
 <div className="mb-5 pb-4 border-b border-border">
 <div className="flex items-center gap-2.5">
 <div className="w-8 h-8 rounded-md bg-accent/10 flex items-center justify-center flex-shrink-0">
 <Car className="h-4 w-4 text-accent" />
 </div>
 <div>
 <p className="text-xs text-muted-foreground">Cadastrando</p>
 <p className="text-sm font-semibold text-foreground font-display">{vehicleName}</p>
 </div>
 </div>
 </div>
 )}

 <div className="relative flex items-start justify-between">
 {/* Connecting line */}
 <div className="absolute left-0 right-0 top-5 h-px bg-border -z-0" />

 {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => {
 const isDone = step < currentStep
 const isActive = step === currentStep
 const isFuture = step > currentStep
 const label = steps[step - 1]

 return (
 <button
 key={step}
 type="button"
 onClick={() => onStepClick?.(step)}
 className="relative flex flex-col items-center gap-2 group z-10 flex-1"
 >
 <div className={cn(
 'w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all duration-200 font-semibold text-sm',
 isDone && 'bg-emerald-500 border-emerald-500 text-white',
 isActive && 'bg-card dark:bg-slate-900 border-accent text-accent shadow-sm ring-4 ring-accent/10',
 isFuture && 'bg-card dark:bg-slate-900 border-border text-muted-foreground group-hover:border-accent/60 group-hover:text-accent/80 transition-colors'
 )}>
 {isDone ? <Check className="h-4 w-4" /> : step}
 </div>

 <span className={cn(
 'text-[0.65rem] font-semibold uppercase tracking-wide text-center leading-tight px-1',
 'hidden sm:block',
 isActive ? 'text-accent' : 'text-muted-foreground'
 )}>
 {label}
 </span>
 </button>
 )
 })}
 </div>
 </div>
 )
}
